import '../CsvJsonInfoPages.scss';


function CodesDescriptions() {

    const data = [
        { length: 1, description: 'CAP Vehicle Code' },
        { length: 2, description: 'CAP Vehicle Identification Number' },
        { length: 3, description: 'Manufacturer Name' },
        { length: 4, description: 'Short Model Description' },
        { length: 5, description: 'Long Model Description' },
        { length: 6, description: 'Introduced Year of earliest derivative' },
        { length: 7, description: 'Discontinued Year of latest derivative' },
        { length: 8, description: 'Short Derivative Description' },
        { length: 9, description: 'Long Derivative Description' },
        { length: 10, description: 'Derivative Introduced Year' },
        { length: 11, description: 'Derivative Discontinued Year' },
        { length: 12, description: 'Currently Available New Vehicle (Y/N)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Used Values - Codes and Descriptons</h1>
            <p> Provides the Manufacturer, Model and Derivative description for each vehicle in the dataset, each vehicle is identified by a unique ID number.<br /><br/>
                <b>File Naming Convention</b></p>

            <b>Used Values</b>
            <p>
                CDEVAL.??? CARS <br />
                LDEVAL.??? LIGHT COMMERCIALS<br />
                HDEVAL.??? HEAVY COMMERCIALS<br />
                BDEVAL.??? BIKES<br />
                IDEVAL.??? IMPORTED CARS
            </p>

            <b>Used Monitor</b>
            <p>
                CDERVU.??? CARS<br />
                LDERVU.??? LIGHT COMMERCIALS<br />
                HDERVU.??? HEAVY COMMERCIALS<br />
                BDERVU.??? BIKES
            </p>

            <b>New Monitor</b>
            <p>
                CDERVN.??? CARS<br />
                LDERVN.??? LIGHT COMMERCIALS<br />
                HDERVN.??? HEAVY COMMERCIALS<br />
                BDERVN.??? BIKES <br /><br />
                The 3 question marks (???) on each of the above files will be replaced with the month i.e. MAR for March.
            </p>

            <b>New Prices & Standard Equipment</b>
            <p>
                CDENEW.??? CARS<br />
                LDENEW.??? LIGHT COMMERCIALS<br />
                HDENEW.??? HEAVY COMMERCIALS<br />
                BDENEW.??? BIKES<br /><br />

                The 3 question marks (???) on each of the above files will be replaced with the day i.e. J12 for January 12th.<br />

            </p>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>DATA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.length}</td>
                                <td>{item.description}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <br />

        </div>
    );

}

export default CodesDescriptions;
